import React from 'react';
import PropTypes from 'prop-types'

const AddMoreButton = ({ onClick }) => {
  const inputEl = React.useRef(null)

  const onClickExtend = () => {
    const value = inputEl.current.value
    if(value.trim().length === 0) {
      return
    }
    onClick({
      label: value,
      value: value,
      disabled: true,
      custom: true
    })

    inputEl.current.value = ''
  }

  return (
    <div className='input-group w-50 mt-2 mb-2'>
      <input ref={inputEl} type='text' className='form-control' placeholder='Add more...' />
      <button className='btn btn-success' type='button' onClick={onClickExtend}>
        <i className='fas fa-plus' />
      </button>
    </div>
  )
}

AddMoreButton.defaultProps = {
  onClick: () => {},
}

AddMoreButton.propTypes = {
  onClickv: PropTypes.func,
}

export default AddMoreButton